<template>
  <div class="sky-step-view-demand-survey-wrapper">
    <div class="child-stage-progress">
      <div class="child-step-content">
        <div class="navs">
          <ul>
            <li
              :class="
                `navs-item ${childItem.value === stepValue ? 'active inprogess' : ''}  ${
                  handelIndex === key ? 'handel-view' : ''
                }  ${activeStageNum > key ? 'progress-done' : 'progress-todo'}  `
              "
              v-for="(childItem, key) in childStep"
              :key="key"
              @click="handelNavItem(childItem, key)"
            >
              {{ childItem.name }}
            </li>
          </ul>
        </div>
        <div class="activite-line">
          <ul>
            <div
              v-for="(childItem, key) in childStep"
              :key="key"
              :class="`navs-item ${handelIndex === key ? 'active' : ''}`"
            ></div>
          </ul>
        </div>
      </div>
    </div>
    <div class="child-stage-content">
      <deploy-step-view-create-project
        :projectId="projectId"
        @changeProjectId="changeProjectId"
        @showBtns="showBtns"
        v-if="activiteViewPage.component === 'SkyDeployStepViewCreateProject'"
        ref="SkyDeployStepViewCreateProject"
      />
      <deploy-step-view-desktop-info
        :projectId="projectId"
        :industryId="industryId"
        @showBtns="showBtns"
        v-if="activiteViewPage.component === 'SkyDeployStepViewDesktopInfo'"
        ref="SkyDeployStepViewDesktopInfo"
      ></deploy-step-view-desktop-info>
      <deploy-step-view-requiremnet-check
        :projectId="projectId"
        @showBtns="showBtns"
        v-if="activiteViewPage.component === 'SkyStepViewRequirementCheck'"
        ref="SkyStepViewRequirementCheck"
      ></deploy-step-view-requiremnet-check>
      <deploy-step-view-network-info
        :projectId="projectId"
        @showBtns="showBtns"
        v-if="activiteViewPage.component === 'SkyStepViewNetworkInfo'"
        ref="SkyStepViewNetworkInfo"
      ></deploy-step-view-network-info>
    </div>
  </div>
</template>
<script>
import { Steps, Step } from 'element-ui'

import DeployStepViewCreateProject from './metadata/DeployStepViewCreateProject'
import DeployStepViewDesktopInfo from './metadata/DeployStepViewDesktopInfo'
import DeployStepViewNetworkInfo from './metadata/DeployStepViewNetworkInfo'
import DeployStepViewRequiremnetCheck from './metadata/DeployStepViewRequiremnetCheck'

import { updateFlowStatus } from '@/api/deliveryProject'

import { getSystemSpecEditState } from '@/api/setting'

export default {
  name: 'SkyStepViewDemandSurvey',
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step,
    DeployStepViewCreateProject,
    DeployStepViewDesktopInfo,
    DeployStepViewRequiremnetCheck,
    DeployStepViewNetworkInfo
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {},
  data: function() {
    return {
      componentKey: 0,
      activeStageNum: 0,
      handelIndex: 0,
      enableCustomChange: true,
      projectId: this.data.projectId,
      industryId: this.data.industryId,
      activiteViewPage: null,
      preHandel: false,
      stepValue: null,
      childStep: [
        {
          name: '项目信息填写',
          component: 'SkyDeployStepViewCreateProject',
          value: 'MDR_DEPLOY_PROJECT_INIT',
          enabelTemp: false,
          status: 'inprogess'
        },
        {
          name: '岗位电脑信息',
          component: 'SkyDeployStepViewDesktopInfo',
          value: 'MDR_DEPLOY_JOB_PC_INFO',
          enabelTemp: true,
          status: 'todo'
        },
        {
          name: '关键需求确认',
          component: 'SkyStepViewRequirementCheck',
          value: 'MDR_DEPLOY_REQUIREMENT_CHECK',
          enabelTemp: true,
          status: 'todo'
        },
        {
          name: '网络信息',
          component: 'SkyStepViewNetworkInfo',
          value: 'MDR_DEPLOY_NETWORK_INFO',
          enabelTemp: true,
          status: 'todo'
        }
      ]
    }
  },
  created() {
    this.stepValue = this.data.stage
    for (let index = 0; index < this.childStep.length; index++) {
      if (this.data.stage === this.childStep[index].value) {
        this.activeStageNum = index
        this.handelIndex = index
      }
    }
    this.activiteViewPage = this.childStep[this.activeStageNum]
  },
  mounted() {
    if (this.data.createBytmp) {
      this.handelNavItem(this.childStep[0], 0)
    }
  },
  methods: {
    handelToAutoNext() {
      this.$emit('handelToAutoNext')
    },
    changeProjectId(pro) {
      this.projectId = pro.projectId
      this.industryId = pro.industryId
      this.$emit('changeProjectId', pro)
    },
    showBtns(params) {
      if (this.stepValue === this.activiteViewPage.value) {
        this.preHandel = false
      } else {
        this.preHandel = true
      }
      if (this.preHandel) {
        this.enableCustomChange = params.enableTabChange
      } else {
        params.nextStep = true
        params.saveStep = false
      }

      this.$emit('showBtns', params)
    },
    handelNavItem(childNavItem, index) {
      getSystemSpecEditState().then(res => {
        if (res.data.content.maintenanceState) {
          this.$store.dispatch('OpenNotification', {
            message: res.data.content.message,
            type: 'error'
          })
          return
        }
        // if (this.activeStageNum < index) {
        //   this.$store.dispatch('OpenNotification', {
        //     message: '当前项目尚未达到该步骤，请点击下一步进行操作',
        //     type: 'error'
        //   })
        //   return
        // }
        // if (!this.enableCustomChange) {
        //   this.$store.dispatch('OpenNotification', {
        //     message: '当前页面包含需要下一步配置的信息，请进行下一步操作',
        //     type: 'error'
        //   })
        //   return
        // }

        this.handelIndex = index
        this.activiteViewPage = childNavItem
        if (this.stepValue === this.activiteViewPage.value) {
          this.preHandel = false
        } else {
          this.preHandel = true
        }
        this.$emit('changeViewIsPreStep', this.enableCustomChange)
      })
    },
    getData() {
      // {
      //     dataChange: true,
      //     busDATA: reqData
      //   }
      var busData = this.$refs[this.activiteViewPage.component].getData()
      return {
        flowStep: this.activiteViewPage.value,
        enabelTemp: this.activiteViewPage.enabelTemp,
        dataChange: busData.dataChange,
        busData: busData.busDATA
      }
    },
    async saveStep() {
      let result = false

      await this.$refs[this.activiteViewPage.component].saveStep().then(res => {
        if (res) {
          this.$store.dispatch('OpenNotification', {
            message: '当前步骤【' + this.activiteViewPage.name + '】已保存',
            type: 'success'
          })
          if (this.preHandel && !this.enableCustomChange) {
            updateFlowStatus({ projectId: this.projectId, flowStatus: this.activiteViewPage.value }).then(res => {
              this.activiteViewPage = this.childStep[this.handelIndex]
              this.activeStageNum = this.handelIndex
              this.$set(this.data, 'stage', this.activiteViewPage.value)
              this.stepValue = this.data.stage
              this.enableCustomChange = true
              this.preHandel = false
              this.$emit('changeEnableCustomChange', this.enableCustomChange)
            })
          }
        }
      })
      return result
    },
    // 返回是否已经跳完
    async skipToNext() {
      if (this.preHandel) {
        this.handelIndex = this.handelIndex + 1
        this.activeStageNum = this.handelIndex
        this.activiteViewPage = this.childStep[this.handelIndex]
        this.stepValue = this.activiteViewPage.value
        if (this.stepValue === this.activiteViewPage.value) {
          this.preHandel = false
        } else {
          this.preHandel = true
        }
        this.$emit('changeViewIsPreStep', this.enableCustomChange)
        return this.handelIndex === this.childStep.length - 1
      } else {
        if (this.handelIndex < this.childStep.length - 1) {
          this.handelIndex = this.handelIndex + 1
          this.activiteViewPage = this.childStep[this.handelIndex]
          this.activeStageNum = this.handelIndex
          this.stepValue = this.activiteViewPage.value
          this.preHandel = false
          updateFlowStatus({ projectId: this.projectId, flowStatus: this.activiteViewPage.value }).then(res => {
            this.enableCustomChange = true
            this.$emit('changeViewIsPreStep', this.enableCustomChange)
          })
          return this.handelIndex === this.childStep.length
        } else {
          return true
        }
      }
    },
    async gotoNextStep() {
      let result = false

      if (this.preHandel) {
        var enableNexta = false
        await this.$refs[this.activiteViewPage.component].gotoNextPreVliate().then(res => {
          enableNexta = res
        })
        if (!enableNexta) {
          return
        }
        await this.$refs[this.activiteViewPage.component].gotoNextStep().then(res => {
          if (res && this.handelIndex < this.childStep.length - 1) {
            this.handelIndex = this.handelIndex + 1
            this.activiteViewPage = this.childStep[this.handelIndex]
            this.activeStageNum = this.handelIndex
            this.$set(this.data, 'stage', this.activiteViewPage.value)
            this.stepValue = this.data.stage
            this.preHandel = false
            updateFlowStatus({ projectId: this.projectId, flowStatus: this.activiteViewPage.value }).then(res => {
              this.enableCustomChange = true
              this.$emit('changeViewIsPreStep', this.enableCustomChange)
            })
          }
        })
        return result
      } else {
        var enableNext = false
        await this.$refs[this.activiteViewPage.component].gotoNextPreVliate().then(res => {
          enableNext = res
        })
        if (!enableNext) {
          return false
        }
        await this.$refs[this.activiteViewPage.component].gotoNextStep().then(res => {
          if (res && this.activeStageNum < this.childStep.length - 1) {
            this.activeStageNum = this.activeStageNum + 1
            this.handelIndex = this.activeStageNum
            this.activiteViewPage = this.childStep[this.activeStageNum]
            this.data.stage = this.activiteViewPage.value
            this.stepValue = this.data.stage
            this.preHandel = false
            updateFlowStatus({ projectId: this.projectId, flowStatus: this.activiteViewPage.value }).then(res => {})
          } else if (res && this.activeStageNum === this.childStep.length - 1) {
            result = true
            return true
          }
          result = false
          return false
        })

        return result
      }
    },
    gotoPreStep() {
      this.$refs[this.activiteViewPage.component].gotoPreStep()
      if (this.activeStageNum > 0) {
        this.activeStageNum = this.activeStageNum - 1
        this.handelIndex = this.activeStageNum
        this.activiteViewPage = this.childStep[this.activeStageNum]
        this.data.stage = this.activiteViewPage.value
        this.stepValue = this.data.stage
        updateFlowStatus({ projectId: this.projectId, flowStatus: this.activiteViewPage.value }).then(res => {})
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(step-view-demand-survey-wrapper) {
  height: 100%;
  .child-stage-progress {
    margin-top: 12px;
    margin-right: 24px;
    height: 40px;
    .child-step-content {
      float: right;
      width: 70%;
    }
  }
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }
  .child-stage-content {
    height: 92%;
  }

  .navs {
    height: 32px;
    line-height: 32px;
    width: 100%;
    text-align: right;
  }

  .activite-line {
    height: 3px;
    line-height: 3px;
    width: 100%;
    text-align: right;
    margin-top: 4px;
  }

  .activite-line .navs-item {
    content: '';
    line-height: 3px;
    height: 3px;
    // background: #1e9fff;
    position: relative;
    display: inline-block;
    width: 18%;
    margin-right: 12px;
  }

  .activite-line .active {
    background: #1e9fff;
  }

  .navs li {
    padding: 0px 10px 0 30px;
    line-height: 36px;
    font-size: 18px;
    margin-right: 12px;
    background: #dceefe;
    display: inline-block;
    color: #1e9fff /*#50abe4*/;
    position: relative;
    text-align: center;
    width: 18%;
  }

  .navs li:after {
    content: '';
    display: block;
    border-top: 18px solid #dceefe;
    border-bottom: 18px solid #dceefe;
    border-left: 18px solid #fff;
    position: absolute;
    right: -17px;
    top: 0;
  }

  .navs li:after {
    content: '';
    display: block;
    border-top: 18px solid transparent;
    border-bottom: 18px solid transparent;
    border-left: 18px solid #dceefe;
    position: absolute;
    right: -17px;
    top: 0;
    z-index: 2;
  }

  .navs li:before {
    content: '';
    display: block;
    border-top: 18px solid #dceefe;
    border-bottom: 18px solid #dceefe;
    border-left: 18px solid #fff;
    position: absolute;
    left: 0px;
    top: 0;
  }

  .navs li:first-child {
    border-radius: 4px 0 0 4px;
    padding-left: 25px;
  }

  .navs li:last-child,
  .cssNavEnd {
    border-radius: 0px 4px 4px 0px;
    padding-right: 25px;
  }

  .navs li:first-child:before {
    display: none;
  }

  .navs li:last-child:after,
  .cssNavEnd:after {
    display: none;
  }

  .navs li.active {
    background: #1e9fff;
    color: #fff;
    cursor: pointer;
  }

  .navs li.active:after {
    border-left-color: #1e9fff;
  }

  .navs li.active:before {
    border-top: 18px solid #1e9fff;
    border-bottom: 18px solid #1e9fff;
  }

  .navs li.progress-done {
    background: #3bb113;
    color: #fff;
    cursor: pointer;
  }

  .navs li.progress-done:after {
    border-left-color: #3bb113;
  }

  .navs li.progress-done:before {
    border-top: 18px solid #3bb113;
    border-bottom: 18px solid #3bb113;
  }
  .changeDetailDialog {
    margin-top: 0px;
  }
}
</style>
